import PropTypes from 'prop-types';
import SkeletonBox from '../../UI/SkeletonBox/SkeletonBox';
import SkeletonInputField from './SkeletonInputField';

export default function SkeletonContent(props) {
  return (
    <>
      <SkeletonBox height={130} />
      {props.step === 1 && <SkeletonInputField />}
    </>
  );
}

SkeletonContent.propTypes = {
  step: PropTypes.number,
};
